import React from 'react';
import { updateLeave as dbUpdateLeave } from '../services/db';
import { CheckCircle, XCircle } from 'lucide-react';
import {
  normalizeHeadDepartmentsFromUser,
  leaveNeedsDepartmentHeadAction,
  resolveLeaveDepartment,
} from '../services/userDb';

export default function TeamLeaves({ currentUser, leaves, employees = [], showToast }) {
  const headDepts = normalizeHeadDepartmentsFromUser(currentUser);
  const teamPending = (leaves || []).filter((l) =>
    leaveNeedsDepartmentHeadAction(l, currentUser, employees)
  );

  const approve = async (id) => {
    try {
      await dbUpdateLeave(id, { status: 'approved' });
      showToast('Leave approved', 'ok');
    } catch (e) {
      showToast('Failed to approve', 'err');
    }
  };

  const reject = async (id) => {
    if (!window.confirm('Reject this leave request?')) return;
    try {
      await dbUpdateLeave(id, { status: 'rejected' });
      showToast('Leave rejected', 'inf');
    } catch (e) {
      showToast('Failed to reject', 'err');
    }
  };

  if (!headDepts.length) {
    return (
      <div className="pg">
        <div className="ph">
          <h2>Team leaves</h2>
          <p style={{ color: 'var(--text2)', fontSize: '13px' }}>You are not assigned as a department head.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pg">
      <div className="ph" style={{ marginBottom: '20px' }}>
        <h2>Team leave approvals</h2>
        <p style={{ color: 'var(--text2)', fontSize: '13px' }}>
          You are the head for <strong>{headDepts.join(', ')}</strong>. All <strong>pending</strong> and <strong>pending (head)</strong> requests from employees in those departments appear here for your approval.
        </p>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {teamPending.length === 0 ? (
          <div style={{ padding: '36px', textAlign: 'center', color: 'var(--text2)' }}>
            No pending leave requests for your department.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'var(--bg-sec)', borderBottom: '1px solid var(--border)' }}>
                <th style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text2)', textAlign: 'left' }}>Employee</th>
                <th style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text2)', textAlign: 'left' }}>Department</th>
                <th style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text2)', textAlign: 'left' }}>Type</th>
                <th style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text2)', textAlign: 'left' }}>Dates</th>
                <th style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text2)', textAlign: 'left' }}>Days</th>
                <th style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text2)', textAlign: 'left' }}>Status</th>
                <th style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text2)', textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {teamPending.map((l) => (
                <tr key={l.id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '12px 16px', fontWeight: '600' }}>{l.emp}</td>
                  <td style={{ padding: '12px 16px', fontSize: '13px', color: 'var(--text2)' }}>
                    {resolveLeaveDepartment(l, employees) || '—'}
                  </td>
                  <td style={{ padding: '12px 16px' }}>{l.type}</td>
                  <td style={{ padding: '12px 16px', fontSize: '13px' }}>
                    {l.from} → {l.to}
                  </td>
                  <td style={{ padding: '12px 16px' }}>{l.days}</td>
                  <td style={{ padding: '12px 16px', fontSize: '12px' }}>
                    <span
                      style={{
                        padding: '3px 8px',
                        borderRadius: '6px',
                        fontWeight: '600',
                        background: l.status === 'pending_head' ? '#fffbeb' : '#eef2ff',
                        color: l.status === 'pending_head' ? '#b45309' : '#3730a3',
                      }}
                    >
                      {l.status === 'pending_head' ? 'Pending (head)' : 'Pending (HR queue)'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                      <button type="button" className="btn btn-ok btn-sm" onClick={() => approve(l.id)} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                        <CheckCircle size={14} /> Approve
                      </button>
                      <button type="button" className="btn btn-ng btn-sm" onClick={() => reject(l.id)} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                        <XCircle size={14} /> Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
